import {useFlag} from '@unleash/proxy-client-react';

const useRawFinancialAccountsFlag = () => useFlag('web-financial-accounts');

export default useRawFinancialAccountsFlag;
